import { ReactNode } from "react";

type ExpandingPanelProps = {
  open: boolean;
  className?: string;
  endHeight: string;
  children: ReactNode;
};

const ExpandingPanel = (props: ExpandingPanelProps) => {
  const open = props.open;
  const className = props.className;
  const children = props.children;
  const endHeight = props.endHeight;

  return (
    <div
      className={`${className} transition-height duration-500 ease-in-out ${
        open ? `${endHeight} overflow-auto` : "h-0 overflow-hidden"
      }`}
    >
      {children}
    </div>
  );
};

export default ExpandingPanel;
